export default __webpack_public_path__ + "static/media/formaredonda.e95cb962.png";